import {
  ActionIcon,
  Button,
  Modal,
  Pagination,
  Select,
  Skeleton,
  Table,
  Badge,
  Text,
  TextInput,
  Group,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import {
  getAgreementTypesApi,
  getObStatusForAg,
  updateObStatus,
} from "../../utilities/apis/agreements";
import {
  Eye,
  History,
  Plus,
  SortAscending,
  SortDescending,
} from "tabler-icons-react";
import { getPartyNames } from "../../utilities/apis/parties";
import { getBussinessUnit } from "../../utilities/apis/serviceProvider";
import { formatIndianNumber, getObStatusText } from "../../utilities/utilities";
import RelatedAgreementModal from "./agreementRelatedModal";

import { IconEdit, IconCircleOff } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { selectUserData } from "../../redux/selectors";
import { showNotification } from "@mantine/notifications";
import { getStatusColor, getStatusText } from "../../utilities/enums";
import UniversalTable from "../../components/Common/UniversalTable";
import TablePagination from "../../components/Common/TablePagination";
import AgreementAuditLogModal from "./AgreementAuditLogModal";
import { Tooltip } from "@mantine/core";

const ObligationStatus = () => {
  const [agreements, setAgreeements] = useState([]);
  const [configs, setConfigs] = useState({
    loading: true,
    pageNumber: 1,
    pageSize: 10,
    count: 0,
  });
  const currentUser = useSelector(selectUserData) || {};
  const loginAs = currentUser.loginAs;
  const estampOption = [
    {
      label: "Yes",
      value: "Yes",
    },
    {
      label: "No",
      value: "No",
    },
  ];
  const loadingStates = {
    LOADING: true,
    NO_ACTIVE_REQUEST: false,
  };
  const [reload, setReload] = useState(false);
  const [filters, setFilters] = useState({});
  const [sortByOptions, setSortByOptions] = useState({
    key: "createdAt",
    value: "desc",
  });
  const handleKeyChange = (val) => {
    const newSortOption = { key: val, value: sortByOptions.value };
    setSortByOptions(newSortOption);
  };
  const toggleOrder = () => {
    const newSortOption = {
      key: sortByOptions.key,
      value: sortByOptions.value === "asc" ? "desc" : "asc",
    };
    setSortByOptions(newSortOption);
  };
  useEffect(() => {
    const getAgreements = async () => {
      const sortOption = { [sortByOptions.key]: sortByOptions.value };
      const response = await apiWrapWithErrorWithData(
        getObStatusForAg({
          pageNumber: configs.pageNumber,
          pageSize: configs.pageSize,
          filters: filters,
          sortBy: sortOption,
        }),
      );
      if (response.success) {
        setAgreeements(response.agreements);
        setConfigs({
          ...configs,
          loading: false,
          count: response.count,
        });
      }
    };
    getAgreements();
  }, [sortByOptions, configs.pageNumber, configs.pageSize, reload]);
  const [businessunitList, setbusinessunitList] = useState([]);
  const [parties, setParties] = useState(["secondparty"]);
  const [obStatusModal, setObStatusModal] = useState(false);
  const [obStatusId, setObStatusId] = useState(0);
  function handleCloseObModal() {
    setObStatusModal(false);
    setObStatusId(0);
  }
  const handleCloseModal = () => {
    // Set the showModal state to false when the modal is closed
    setShowModal(false);
  };
  const [showModal, setShowModal] = useState(false);
  const [showAuditId, setShowAuditId] = useState(null);
  const [showModalRelated, setShowModalRelated] = useState(false);
  const [relatedAgreementId, setRelatedAgreementId] = useState(null);

  const handleSearchClick = (id) => {
    setShowAuditId(id);
    setShowModal(true);
  };

  const handlePlusClick = (id) => {
    setRelatedAgreementId(id);
    setShowModalRelated(true);
  };

  const handleCloseRelatedAgreementModal = () => {
    setShowModalRelated(false);
    setRelatedAgreementId(null);
  };

  useEffect(() => {
    const fetchBusinessUnits = async () => {
      try {
        const { data } = await getBussinessUnit();
        if (data) {
          setbusinessunitList(data.businessunitList || []);
        } else {
          console.error("Invalid business unit response format:", data);
        }
      } catch (error) {
        console.error("Error fetching business units:", error);
      }
    };

    const getPartyName = async () => {
      const response = await apiWrapWithErrorWithData(getPartyNames());
      if (response.success) {
        console.log("party de rha h bro: ", response);
        setParties(response.parties);
      }
    };
    getPartyName();
    fetchBusinessUnits();
  }, []);

  const [agreementTypeOptions, setAgreementTypeOptions] = useState([]);
  const [transformedData, settransformedData] = useState([]);

  const getAgreementTypes = async () => {
    const resp = await apiWrapWithErrorWithData(getAgreementTypesApi());

    if (resp?.success && resp?.typesOfAgreement) {
      const uniqueValues = Array.from(new Set(resp.typesOfAgreement));

      const temp = uniqueValues.map((item) => ({
        label: item,
        value: item,
      }));

      setAgreementTypeOptions(temp);
    }
  };

  useEffect(() => {
    getAgreementTypes();
  }, []);

  useEffect(() => {
    if (businessunitList.length > 0) {
      settransformedData(
        businessunitList.map((unit) => ({
          value: unit.id + "",
          label: unit.name,
        })),
      );
    }
  }, [businessunitList]);

  const onViewClick = (agreementId) => {
    const url = `/app/agreements_manager/agreements/details/${agreementId}`;
    window.open(url, "_blank"); // '_blank' specifically tells the browser to open in a new tab/window
  };

  const handleNotRequired = async () => {
    const response = await apiWrapWithErrorWithData(
      updateObStatus({
        agreementId: obStatusId,
        obStatus: "not required",
      }),
    );

    if (response.success) {
      setObStatusId(0);
      setObStatusModal(false);

      showNotification({
        color: "green",
        title: "Obligation Status",
        message: "Obligation marked as Not Required successfully.",
      });

      setReload((prev) => !prev);
    }
  };

  const subTextStyle = {
    fontSize: "10px",
    fontWeight: 400,
    opacity: 0.7,
    lineHeight: 1.2,
  };

  const formatDate = (dateString) => {
    if (!dateString) return "--";

    return new Date(dateString).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };

  const tableHeaders = [
    {
      // CIN / Job Order
      label: (
        <div>
          <div>CIN</div>
          <div style={subTextStyle}>JOB ORDER</div>
        </div>
      ),
      render: (row) => (
        <div className="flex flex-col">
          <Text size="xs" weight={600} color="#2089ae">{`#${row.id}`}</Text>
          <Text size="10px" color="dimmed">
            {row.jobOrder || "NO JO"}
          </Text>
        </div>
      ),
    },
    {
      // Category / BU
      label: (
        <div>
          <div>Category</div>
          <div style={subTextStyle}>BU</div>
        </div>
      ),
      render: (row) => (
        <div className="flex flex-col">
          <Text size="xs" weight={500}>
            {row.agreementData?.json?.typeOfAgreement || "--"}
          </Text>
          <Text size="10px" color="dimmed">
            {row.agreementData?.json?.location || "--"}
          </Text>
        </div>
      ),
    },
    {
      label: "ACV (INR)",
      render: (row) => (
        <Text size="xs" weight={700}>
          {formatIndianNumber(row.agreementValue)}
        </Text>
      ),
    },
    {
      // Brand Name / Second Party
      label: (
        <div>
          <div>Brand Name</div>
          <div style={subTextStyle}>SECOND PARTY</div>
        </div>
      ),
      render: (row) => (
        <div className="flex flex-col" style={{ maxWidth: "180px" }}>
          <Text
            size="xs"
            weight={500}
            truncate
            title={row.agreementData?.json?.brandName}
          >
            {row.agreementData?.json?.brandName || "N/A"}
          </Text>
          <Text
            size="10px"
            color="dimmed"
            truncate
            title={row.agreementData?.json?.secondParty?.name}
          >
            {row.agreementData?.json?.secondParty?.name || "--"}
          </Text>
        </div>
      ),
    },
    {
      label: "Status",
      render: (row) => (
        <Badge
          variant="light"
          size="xs"
          color={getStatusColor(row.status)}
          radius="xl"
        >
          {getStatusText(row.status)}
        </Badge>
      ),
    },
    {
      label: "Contract Date",
      render: (row) => (
        <Text size="xs">
          {row.createdAt ? formatDate(row.createdAt) : "--"}
        </Text>
      ),
    },
    {
      label: "Obligation Status",
      render: (row) => {
        const status = getObStatusText(row.obligationStatus);
        return (
          <Badge color={status.color} size="xs" variant="filled">
            {status.text}
          </Badge>
        );
      },
    },
    {
      label: "Actions",
      align: "right",
      render: (row) => (
        <div className="flex flex-row justify-end items-center gap-1">
          {row.obligationStatus !== "not required" && (
            <Tooltip label="Mark Obligation as not required" withArrow>
              <ActionIcon
                variant="subtle"
                color="red"
                onClick={() => {
                  setObStatusId(row.id);
                  setObStatusModal(true);
                }}
              >
                <IconCircleOff size={16} />
              </ActionIcon>
            </Tooltip>
          )}
          {row.relationshipWith ? (
            <Tooltip label="View Related Agreements" withArrow>
              <ActionIcon
                variant="subtle"
                color="blue"
                onClick={() => {
                  handlePlusClick(row.id);
                }}
              >
                <Plus size={16} />
              </ActionIcon>
            </Tooltip>
          ) : (
            <Tooltip label="No Related Agreements" withArrow>
              <div
                style={{ width: 28 }}
                className="flex justify-center text-gray-400 text-xs"
              >
                --
              </div>
            </Tooltip>
          )}

          <Tooltip label="View Agreement Details" withArrow>
            <ActionIcon
              variant="subtle"
              color="blue"
              onClick={() => onViewClick(row.id)}
            >
              <Eye size={16} />
            </ActionIcon>
          </Tooltip>

          <Tooltip label="View History" withArrow>
            <ActionIcon
              variant="subtle"
              color="blue"
              onClick={() => handleSearchClick(row.id)}
            >
              <History size={16} />
            </ActionIcon>
          </Tooltip>
        </div>
      ),
    },
  ];
  return (
    <div>
      {showModalRelated && (
        <Modal
          overflow="inside"
          opened
          onClose={handleCloseRelatedAgreementModal} // Call the handler on modal close
          size="calc(80vw)"
        >
          <RelatedAgreementModal agreementId={relatedAgreementId} />
        </Modal>
      )}

      {showModal && (
        <Modal
          opened={showModal}
          onClose={() => {
            setShowModal(false);
            setShowAuditId(null);
          }}
          size="85%"
          centered
          title={null}
          styles={{
            body: {
              paddingTop: 10,
            },
          }}
        >
          <AgreementAuditLogModal agreementId={showAuditId} />
        </Modal>
      )}

      <Modal
        opened={obStatusModal}
        onClose={handleCloseObModal}
        centered
        title="Update Obligation Status"
      >
        <Text mb="lg" sx={{ textTransform: "none" }}>
          Are you sure you want to mark this agreement as
          <strong> not required</strong>?
        </Text>

        <Group position="right">
          <Button variant="default" onClick={handleCloseObModal}>
            Cancel
          </Button>

          <Button color="orange" onClick={handleNotRequired}>
            Mark as not required
          </Button>
        </Group>
      </Modal>
      <h1
        style={{
          fontSize: "22px",
          fontWeight: "600",
          letterSpacing: "1px",
          fontFamily: "Lato",
          whiteSpace: "nowrap",
          paddingBottom: "13px",
          position: "relative",
          color: "#5F6464",
          // margin: "0 auto"
        }}
      >
        Obligation Status
      </h1>

      {configs.loading && (
        <div className="flex flex-col">
          {Array.from({ length: 10 }).map((i) => (
            <Skeleton key={i} height={30} radius="md" className="my-1 w-full" />
          ))}
          <div className="flex flex-row justify-center">
            <Skeleton height={40} radius="md" className="w-40" />
          </div>
        </div>
      )}
      {!configs.loading && agreements && (
        <>
          <div className="flex w-full justify-between items-center">
            <div className="flex flex-col">
              <div className="flex flex-row-sm">
                {/* <Text size="xs" className="mb-2" color="gray">
                      Case sensitive search
                    </Text> */}
                <div className="flex items-center">
                  {/* <TextInput
                        value={listing.searchString}
                        onChange={(input) => {
                          const val = getValueForInput(input);
                          setListing((prevState) => ({
                            ...prevState,
                            searchString: val,
                          }));
                        }}
                        placeholder="Type to search..."
                        icon={<Search size={14} />}
                      /> */}

                  {/* <Select
                      className="mx-2"
                      placeholder="estamp"
                      value={filters.estamp || null}
                      onChange={(val) => {
                        setFilters((prevState) => ({
                          ...prevState,
                          estamp: val,
                        }));
                      }}
                      data={estampOption}
                      style={{ minWidth: "228px" }}
                    /> */}
                  <Select
                    className="mx-2"
                    placeholder="Select Obligation Status"
                    value={filters.obligationStatus || null}
                    onChange={(val) => {
                      setFilters((prevState) => ({
                        ...prevState,
                        obligationStatus: val,
                      }));
                    }}
                    data={[
                      { label: "Pending", value: "NA" },
                      { label: "Created", value: "created" },
                      { label: "Not Required", value: "not required" },
                    ]}
                    style={{ minWidth: "228px" }}
                  />
                  <Select
                    className="mx-2"
                    placeholder="Select Business Unit"
                    value={filters.mapBusinessunit || null}
                    data={transformedData}
                    onChange={(value) => {
                      setFilters((prevState) => ({
                        ...prevState,
                        mapBusinessunit: value,
                      }));
                    }}
                    style={{ minWidth: "228px" }}
                  />
                  <TextInput
                    className="mx-2"
                    placeholder="Type Job Order"
                    value={filters?.jobOrder?.contains || null}
                    onChange={(e) =>
                      setFilters((preState) => ({
                        ...preState,
                        jobOrder: { contains: e.target.value },
                      }))
                    }
                    maw={400}
                    mx="auto"
                    style={{ minWidth: "228px" }}
                  />
                  <Select
                    className="mx-2"
                    // value={filters.partyName || null}
                    onChange={(value) => {
                      // const val = getValueForInput(input);
                      setFilters((prevState) => ({
                        ...prevState,
                        OR: [
                          {
                            secondParty: {
                              path: "$.name",
                              string_contains: value,
                              // mode: "insensitive",
                            },
                          },
                          {
                            secondParty: {
                              path: "$.brandName",
                              string_contains: value,
                            },
                          },
                        ],
                      }));
                    }}
                    placeholder="Party Name"
                    type="text"
                    searchable
                    data={parties}
                    style={{ minWidth: "400px" }}
                  />
                </div>
                <Button
                  className="mx-2"
                  variant="outline"
                  onClick={() => setReload(!reload)}
                >
                  Search
                </Button>
                <Button
                  className="mx-2"
                  onClick={() => {
                    // setFilters({}), setReload(!reload);
                    window.location.reload();
                  }}
                >
                  Clear
                </Button>
              </div>
            </div>
          </div>
          <br />
        </>
      )}

      {/* <div className="flex float-right">
          <div className="flex">
            <Select
              value={sortByOptions.key}
              onChange={(val) => handleKeyChange(val)}
              data={[
                { label: "created at", value: "createdAt" },
                { label: "end date", value: "dueDateOfContract" },
                { label: "type of agreement", value: "typeOfAgreement" },
                { label: "ain", value: "id" },
                { label: "agreement value", value: "agreementValue" },
              ]}
            />
            <ActionIcon className="mx-2" onClick={toggleOrder}>
              {sortByOptions.value === "asc" ? (
                <SortAscending size={32} />
              ) : (
                <SortDescending size={32} />
              )}
            </ActionIcon>
          </div>
        </div> */}
      {configs.loading ? (
        <div className="flex flex-col gap-2">
          {Array.from({ length: 10 }).map((_, i) => (
            <Skeleton key={i} height={40} radius="md" />
          ))}
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          {agreements && agreements.length > 0 ? (
            <>
              <UniversalTable
                headers={tableHeaders}
                data={agreements}
                loading={configs.loading}
              />

              <TablePagination
                totalCount={configs.count}
                page={configs.pageNumber}
                pageSize={configs.pageSize}
                dataLength={agreements.length}
                onPageChange={(page) =>
                  setConfigs({ ...configs, pageNumber: page })
                }
                onPageSizeChange={(s) =>
                  setConfigs({
                    ...configs,
                    pageSize: parseInt(s),
                    pageNumber: 1,
                  })
                }
              />
            </>
          ) : (
            <div
              className="flex justify-center items-center text-gray-500"
              style={{ minHeight: "300px" }}
            >
              No agreements found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ObligationStatus;
